import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api.service';

const defaultLegalUrls = {
  termsUrl: 'https://lawwwing.com/documents/c01c2ae1-7fb6-4c08-8e9a-4a921c72dc84/terms-and-conditions/es/',
  privacyUrl: 'https://lawwwing.com/documents/c01c2ae1-7fb6-4c08-8e9a-4a921c72dc84/privacy-policy/es/'
};

const DomainContext = createContext({
  displayName: 'Pamplonews',
  appName: 'Rasca y Gana de Pamplonews',
  shortName: 'Rasca y Gana',
  termsUrl: defaultLegalUrls.termsUrl,
  privacyUrl: defaultLegalUrls.privacyUrl,
  cookieScriptUrl: null,
  cookieScriptLwid: null,
  cookieScriptDataId: null,
  loading: true
});

export const useDomain = () => useContext(DomainContext);

export const DomainProvider = ({ children }) => {
  const [config, setConfig] = useState({
    displayName: 'Pamplonews',
    appName: 'Rasca y Gana de Pamplonews',
    shortName: 'Rasca y Gana',
    termsUrl: defaultLegalUrls.termsUrl,
    privacyUrl: defaultLegalUrls.privacyUrl,
    cookieScriptUrl: null,
    cookieScriptLwid: null,
    cookieScriptDataId: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDomainConfig = async () => {
      try {
        const response = await api.get('/domain/config');
        if (response.data?.success && response.data) {
          const newConfig = {
            displayName: response.data.displayName || 'Pamplonews',
            appName: response.data.appName || 'Rasca y Gana de Pamplonews',
            shortName: response.data.shortName || 'Rasca y Gana',
            termsUrl: response.data.termsUrl || defaultLegalUrls.termsUrl,
            privacyUrl: response.data.privacyUrl || defaultLegalUrls.privacyUrl,
            cookieScriptUrl: response.data.cookieScriptUrl || null,
            cookieScriptLwid: response.data.cookieScriptLwid || null,
            cookieScriptDataId: response.data.cookieScriptDataId || null
          };
          setConfig(newConfig);
          document.title = newConfig.appName;
        }
      } catch (error) {
        console.error('Error cargando configuración de dominio:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDomainConfig();
  }, []);

  return (
    <DomainContext.Provider value={{ ...config, loading }}>
      {children}
    </DomainContext.Provider>
  );
};
